
import { Container, Row, Col, Nav } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import twdaImg from '../assets/img/twdacover.jpg'

export const FullSTackTraining = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h3>3 MONTHS INTENSIVE COURSE</h3>
                <h1><span className='quoteHeader'>Full Stack (MERN)</span> Development Training.</h1>
                <h4>Totlesoft Web Development Academy (TWDA)</h4><br />

                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='/payment' rel="noreferrer" target='_blank'><img src={twdaImg} alt="example Img"/></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                <h5>This intensive practical Web Development Course is design to help you master the MERN Stack Technology in programming in the shortest possible time.</h5><br />

                  <h3>Special Offer Currently Open. <span className="chris">50% Off - Ending Soon!</span> Act now!</h3><br />

                  <p>This course is designed and intended for both beginners who want to shift or start a career in web development and also developers who wants to learn deeper in web development tech-skills. A step by step guide along with computer tips and techniques is provided during this course. The course covers an in-depth project-based study in HTML, CSS & Javascript etc and the students will also learn how to launch or deploy their website online. This is focused on learning by doing approach instead of theories. Concepts and theories are also being taught, but only when it is very relevant to create an actual project.</p><br/>

                  <h5>We'll start by learning HTML, CSS, and JavaScript, the fundamental technologies of the web. Then we'll move on to more advanced topics like React, Node js, and MongoDB. By the end of the course, you'll  build  different projects ranging from a simple website to a fully-fledged web app.</h5><br />
                  
                  <p>Learning a skill has now become way easier with this one and only Online course that provides you with the needed environment, materials, and mentorship you need to not just learn one of the most profitable skills, but also ensures you master and make money from it.</p>
                  <p>Before you miss out on this once in a lifetime opportunity so many Web Developers have enjoyed, hear me out.</p>
                  <p>Totlesoft Web Development Academy (TWDA) is the most resourceful Web Development online course that helps you learn effectively in no time the theories, practicals and best practices in Web Design and Development that can turn you into a professional in less than 90 Days.</p>
                  <p>So whether you're a complete beginner or an experienced web developer looking to stay up-to-date with the latest changes, this course is for you. Enrol now and let's get started!</p><br />

                                    
                  <h3>What will I benefit from this training?</h3>
                  <p>If you learn and practice all you would be taught in this practical course, you would be able to do the following without stress or any wasting of time.</p>
                  <p>💡 Understand HTML (Hypertext Markup Language) and why it is called the Structure of websites.</p>
                  <p>💡 Understand CSS (Cascading Style Sheets) and how it is used to describe presentations of document written in a markup langfuage such as HTML or XML.</p>
                  <p>💡 Understand Javascript (JS) and why it's one of the core technologies of the World Wide Web</p>
                  <p>💡 Understand React.JS (A Frontend Javascript Library) and how to use it to build powerful user interfaces UI/UX based on components.</p>
                  <p>💡 Understand Express.JS (A Backend web application framework on Node.JS ) and how to use it to build RESTFul APISs.</p>
                  <p>💡 Understand MongoDB (A source-available cross-platform document-oriented database program) and how to use it for high volume data storage</p>
                  <p>💡 Understand Node.JS (A cross-platform, open-source server environment that can run on Windows, Linux, Unix, macOS, and more) and how it executes JavaScript code outside a web browser</p>
                  <br/>
                  <h2>A More Detailed Syllabus</h2>
                  <h5>INTRODUCTION TO WEB DEVELOPMENT</h5>
                  <p>💡 What is web development?</p>
                  <p>💡 How does websites work?</p>
                  <p>💡 Advantages of learning web developmen</p>
                  <p>💡 GitHub</p>
                  <p>💡 and More...</p><br />

                  
                  <h5>HTML: Hypertext Markup Language</h5>
                  <p>💡 What is HTML?</p>
                  <p>💡 Structure of Webpage</p>
                  <p>💡 Tags</p>
                  <p>💡 Adding and formatting texts, title, paragraph, and body</p>
                  <p>💡 Lists: Ordered/Unordere</p>
                  <p>💡 Images</p>
                  <p>💡 Forms</p>
                  <p>💡 Links</p>
                  <p>💡 Table</p>
                  <p>💡 Anchor Tags</p>
                  <p>💡 Divs, Span, Section</p>
                  <p>💡 and More...</p><br />


                  <h5>CSS: Cascading Style Sheets</h5>
                  <p>💡 Introduction</p>
                  <p>💡 Inline, Internal, & External styling</p>
                  <p>💡 CSS Display</p>
                  <p>💡 Backgrounds, Borders, Margins, Padding</p>
                  <p>💡 Font Styling</p>
                  <p>💡 Stylings Lists</p>
                  <p>💡 Styling Tables and Forms</p>
                  <p>💡 Gradients</p>
                  <p>💡 Font Awesom</p>
                  <p>💡 Tool Tips</p>
                  <p>💡 Buttons</p>
                  <p>💡 Transitions, Transformation, Animations</p>
                  <p>💡 Box sizing</p>
                  <p>💡 Flex and Grid</p>
                  <p>💡 Project 1: Build A Simple Landing Page with HTML & CSS only</p>
                  <p>💡 Project 2: Build A Todo App using HTML & CSS</p>
                  <p>💡 Project Discuss: Responsive Media Querries and Keyframes</p><br />

                  
                  <h5>Javascript</h5>
                  <p>💡 Introduction</p>
                  <p>💡 Variables, scoping, Data type</p>
                  <p>💡 Strings and Number</p>
                  <p>💡 Operators and loop</p>
                  <p>💡 Functions</p>
                  <p>💡 Arrays</p>
                  <p>💡 Linked List, Stacks, Queues & Maps</p>
                  <p>💡 Understanding and working with DOM</p>
                  <p>💡 Prototypes</p>
                  <p>💡 Closure</p>
                  <p>💡 Local Storage</p>
                  <p>💡 Promises</p>
                  <p>💡 ES6</p>
                  <p>💡 and more...</p>
                  <p>💡 Project 3: Add Functionality to site Build with HTML & CSS</p>
                  <p>💡 Project 4: Build A Complete Website using HTML, CSS & Javascript</p>
                  <p>💡 Project Discuss: How to solve world problems using codes.</p><br />

                  <h5>React.JS</h5>
                  <p>💡 Introduction</p>
                  <p>💡 Install node</p>
                  <p>💡 Create an app using create-react-app</p>
                  <p>💡 Understanding basics of react app</p>
                  <p>💡 Understanding JSX</p>
                  <p>💡 Understanding virtual DOMS, Single page apps</p>
                  <p>💡 React Lifecycle</p>
                  <p>💡 States</p>
                  <p>💡 Class components vs functions components</p>
                  <p>💡 Event handling</p>
                  <p>💡 Props</p>
                  <p>💡 Building a basic Forms using React</p>
                  <p>💡 Routes</p>
                  <p>💡 Conditional Rendering</p>
                  <p>💡 Pure Components</p>
                  <p>💡 High Order components</p>
                  <p>💡 Controlled vs Uncontrolled component</p>
                  <p>💡 Axios</p>
                  <p>💡 Server-Side Rendering</p>
                  <p>💡 React Hooks</p>
                  <p>💡 Project 5: Build A Complete E-Commerce Website using React.JS</p>
                  <p>💡 Project Discuss: Using GitHub and pushing codes to Repositories</p><br />


                  <h5>Express.JS/Node.JS</h5>
                  <p>💡 Introduction</p>
                  <p>💡 Simple Server</p>
                  <p>💡 Response Types: HTML, JSON</p>
                  <p>💡 Express Intro</p>
                  <p>💡 Controllers, Routes & Models</p>
                  <p>💡 Middlewares</p>
                  <p>💡 REST API</p>
                  <p>💡 API Authentication</p>
                  <p>💡 and more...</p>
                  <p>💡 Project 6: Build A Simple Express Server and make it run on PORT 5000</p>
                  <p>💡 Project Discuss: Cors</p><br />


                  
                  <h5>MongoDB (Database)</h5>
                  <p>💡 Introduction</p>
                  <p>💡 SQL vs NO-SQL</p>
                  <p>💡 MongoDB / DynamoDB overview</p>
                  <p>💡 Installing MongoDB</p>
                  <p>💡 Connecting and inserting data</p>
                  <p>💡 Deleting and updating data</p>
                  <p>💡 CRUD</p>
                  <p>💡 and more...</p>
                  <p>💡 Project 6: Build A RESTFul API and poform a CRUD Operation</p>
                  <p>💡 Project 7: Test Endpoints using Postman/Rest-Client</p>
                  <p>💡 Project Discuss: File/Folder Organizational Structuring</p><br />



                  
                  <h3>FREQUENTLY ASK QUESTIONS</h3><br />
                  <h5 className="chris">What are the basic requirements to start?</h5>
                  <p>A Laptop/Desktop Computer, a good internet connection and a heart to learn</p><br />

                  <h5 className="chris">How long will the training last?</h5>
                  <p>The training is design to last maximum 90days but for individuals with stronger technical sense it might ends in lesser days</p><br />

                  <h5 className="chris">When and where do I get the training after payment?</h5>
                  <p>This course is an online course with some of the materials stored on our google drive which you will have access to after registration and some trainings will be given via live classes. </p><br />

                  <h5 className="chris">Can a beginner like me that doesn't have any coding or tech knowledge be able to learn this course?</h5>
                  <p>YES, this training is targeted at people like you. Anybody that can read can get this course and rose to become a senior full stack developer</p><br />

                  <h5 className="chris">Can I enroll tomorrow?</h5>
                  <p>YES, you can get this course whenever you want, but you might not meet it at the current price.</p><br />

                  <h5 className="chris">If I ran into any issue, will there be any help or support from you?</h5>
                  <p>YES, Totlesoft Web Development Academy has a very strong support team that are ever ready to guide you all the way. You will have access to the group link after payment.</p><br />

                  
                  <Nav.Link href='/payment' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h5 className="chris">Suported Currencies</h5>
                  <p>NGN, USD, GBP, GHS, KES, ZAR, TZS, UGX, XAF, XOF, RWF</p><br />
                  
                  <h5 className="chris">Payment Options</h5>
                  <p>Bank, Bank Transfer, Visa/Master Card, USSD</p><br />

                  <Nav.Link href='/payment' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <p>If you cannot make payment via the link above you can also reach us on whatsApp for other options.</p>
                  <p className="chris"><a href="https://wa.me/2348163913697">WhatsApp Link</a></p><br />

                  <h5>Act Now!</h5><br />

                  <h3>Note: <span className="chris">Latest Update from Totlesoft Marketing Team:</span></h3>
                  <h5>Please do well to fill in your correct information at the payment page</h5>
                  <p>Name: VERY IMPORTANT</p>
                  <p>Email: VERY IMPORTANT</p>
                  <p>Phone: OPTIONAL</p><br />

                  <Nav.Link href='/academy' rel="noreferrer"><h3>Return to Academy Home Page</h3></Nav.Link><br />

                 
                 </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

